'use client';

import { useRouter } from 'next/navigation';
import React, { FormEvent, useState } from 'react';
import { generateRoomId } from '@/lib/client-utils';
import styles from '../styles/Home.module.css';

function CameraIcon() {
  return (
    <svg width="34" height="34" viewBox="0 0 24 24" fill="none" aria-hidden>
      <rect x="2" y="6" width="13" height="12" rx="2.5" stroke="currentColor" strokeWidth="1.8" />
      <path d="M15 10.5l5.2-3.1c.5-.3 1.1.1 1.1.7v7.8c0 .6-.6 1-1.1.7L15 13.5" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    </svg>
  );
}

function LinkIcon() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path d="M10 14a4.5 4.5 0 006.4 0l3.2-3.2a4.5 4.5 0 10-6.4-6.4L11.5 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M14 10a4.5 4.5 0 00-6.4 0l-3.2 3.2a4.5 4.5 0 106.4 6.4L12.5 18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

export default function Page() {
  const router = useRouter();
  const [joinCode, setJoinCode] = useState('');
  const [joinError, setJoinError] = useState(false);

  const createMeeting = async () => {
    const roomId = generateRoomId();
    const link = `${window.location.origin}/rooms/${roomId}`;
    try {
      // жест пользователя есть (это обработчик клика) — clipboard доступен
      await navigator.clipboard.writeText(link);
    } catch {
      // без буфера (старый браузер/запрет) — просто переходим, ссылку покажет комната
    }
    router.push(`/rooms/${roomId}`);
  };

  const joinMeeting = (event: FormEvent) => {
    event.preventDefault();
    let code = joinCode.trim();
    if (!code) return;
    // можно вставить полную ссылку-приглашение вида https://live.setere.ru/rooms/xxxx-xxxx
    const fromLink = code.match(/\/rooms\/([A-Za-z0-9-]+)/);
    if (fromLink) code = fromLink[1];
    code = code.split('?')[0].split('#')[0];
    if (!/^[A-Za-z0-9-]{3,64}$/.test(code)) {
      setJoinError(true);
      return;
    }
    setJoinError(false);
    router.push(`/rooms/${code}`);
  };

  return (
    <main className={styles.main} data-lk-theme="default">
      <div className={styles.landingCard}>
        <button className={styles.bigButton} onClick={createMeeting}>
          <CameraIcon />
          <span className={styles.bigButtonLabel}>Создать новую встречу</span>
          <span className={styles.bigButtonHint}>ссылка-приглашение появится автоматически</span>
        </button>

        <div className={styles.orDivider}>
          <span>или</span>
        </div>

        <form className={styles.joinForm} onSubmit={joinMeeting}>
          <input
            className={joinError ? `${styles.joinInput} ${styles.joinInputError}` : styles.joinInput}
            placeholder="Код встречи или ссылка-приглашение"
            value={joinCode}
            onChange={(e) => {
              setJoinCode(e.target.value);
              setJoinError(false);
            }}
            aria-label="Код встречи или ссылка-приглашение"
          />
          <button type="submit" className={styles.bigButtonSecondary}>
            <LinkIcon />
            <span className={styles.bigButtonLabel}>Подключиться к встрече</span>
          </button>
        </form>

        {joinError && (
          <p className={styles.joinErrorText}>
            Не похоже на код или ссылку встречи — проверьте и попробуйте ещё раз.
          </p>
        )}
      </div>
    </main>
  );
}
